import * as Sentry from '@sentry/browser';
import { environment } from '../../environments/environment';

export function initiateSentry() {
  Sentry.init({
    dsn: environment.sentryUrl,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Adjust this value based on your environment to see logs.
    tracesSampleRate: environment.sentryTracesSampleRate, // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
    tracePropagationTargets: environment.sentryTracePropagationTargets, // This is required to ensure that Sentry can capture traces across different services.
    replaysSessionSampleRate: environment.sentryReplaysSessionSampleRate, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: environment.sentryReplaysOnErrorSampleRate, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: environment.sentryEnvironment,
  });
}
